// Friendly dictionary words only: keep suggestions readable and avoid shipping the full trie.
const ADJECTIVES = [
  'brave',
  'bright',
  'calm',
  'clever',
  'cozy',
  'eager',
  'fuzzy',
  'gentle',
  'happy',
  'jolly',
  'kind',
  'lucky',
  'merry',
  'quiet',
  'sunny',
  'witty',
];
const NOUNS = [
  'badger',
  'bunny',
  'cloud',
  'comet',
  'fern',
  'finch',
  'fox',
  'gecko',
  'maple',
  'otter',
  'panda',
  'peach',
  'robin',
  'sprout',
  'tiger',
  'wren',
];
const NAMES = ADJECTIVES.flatMap((adjective) => NOUNS.map((noun) => `${adjective}-${noun}`));

/** Rerolls always differ from the current name; names are suggestions, not unique IDs. */
export function generateName(previous = '', random: () => number = Math.random): string {
  const previousIndex = NAMES.indexOf(previous);
  let index = Math.floor(random() * (NAMES.length - (previousIndex >= 0 ? 1 : 0)));
  if (previousIndex >= 0 && index >= previousIndex) index++;
  return NAMES[index]!;
}
